module.exports = __webpack_public_path__ + "img/smartAgriculture.39839c68.png";